import { Box, Drawer, Typography, IconButton, TextField, Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { IoClose } from 'react-icons/io5';
import { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { HolidayForm } from './OffDays';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface Props {
  open: boolean;
  handleClose: () => void;
  editIndex: number | null;
  append: (val: HolidayForm) => void;
  update: (index: number, val: HolidayForm) => void;
  holidays: HolidayForm[];
}

export default function AddOffDayDrawer({ open, handleClose, editIndex, append, update, holidays }: Props) {
  const [date, setDate] = useState<Dayjs | null>(null);
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (editIndex !== null) {
      const holiday = holidays[editIndex];
      setDate(holiday?.date ? dayjs(holiday.date) : null);
      setReason(holiday?.reason || '');
    } else {
      setDate(null);
      setReason('');
    }
  }, [editIndex, holidays]);

  const handleSubmit = () => {
    if (!date || !reason.trim()) return;

    const payload: HolidayForm = {
      date: date.format('YYYY-MM-DD'),
      reason
    };

    if (editIndex !== null) {
      update(editIndex, payload);
    } else {
      append(payload);
    }

    handleClose();
  };

  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={handleClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 400, md: 600 }
        }
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 3,
          py: 2,
          borderBottom: '1px solid #DEDEDE',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Typography variant='h6'>{editIndex !== null ? 'Edit Off Day' : 'Add Off Day'}</Typography>
        <IconButton onClick={handleClose}>
          <IoClose />
        </IconButton>
      </Box>

      {/* Content */}
      <Box p={3}>
        <Grid container spacing={3}>
          <Grid size={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label='Date'
                value={date}
                onChange={(newValue) => setDate(newValue)}
                disablePast
                slotProps={{
                  textField: {
                    fullWidth: true
                  }
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid size={12}>
            <TextField
              label='Reason'
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              multiline
              rows={3}
              required
              fullWidth
            />
          </Grid>
        </Grid>

        <Box mt={3} display='flex' justifyContent='flex-end' gap={2}>
          <Button variant='outlined' onClick={handleClose}>
            Cancel
          </Button>
          <Button variant='contained' onClick={handleSubmit} disabled={!date || !reason.trim()}>
            Save
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
